"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var Ticket_1 = __importDefault(require("./components/Ticket"));
var TicketPage_module_scss_1 = __importDefault(require("./TicketPage.module.scss"));
var appConfig_1 = __importDefault(require("../../config/appConfig"));
var getStoredTickets = function (sessionId) {
    if (typeof sessionStorage === "undefined" || !sessionId) {
        return [];
    }
    var rawTickets = sessionStorage.getItem("pos.purchase.".concat(sessionId));
    if (!rawTickets) {
        return [];
    }
    try {
        var parsedTickets = JSON.parse(rawTickets);
        return Array.isArray(parsedTickets) ? parsedTickets : [];
    }
    catch (_a) {
        return [];
    }
};
var TicketPage = function () {
    var _a, _b;
    var t = (0, react_i18next_1.useTranslation)().t;
    var searchParams = (0, react_router_dom_1.useSearchParams)()[0];
    var sessionId = ((_a = searchParams.get("session-id")) === null || _a === void 0 ? void 0 : _a.trim()) || "";
    var tickets = (0, react_1.useMemo)(function () { return getStoredTickets(sessionId); }, [sessionId]);
    var examWebBaseUrl = ((_b = appConfig_1.default.getExamWebBaseUrl()) === null || _b === void 0 ? void 0 : _b.trim()) || "";
    var handleGoExam = function (ticket) {
        var query = new URLSearchParams({
            "exam-id": ticket.itemId,
            "student-id": ticket.seatId,
            "seat-id": ticket.seatId,
            passkey: ticket.passkey
        });
        var normalizedBaseUrl = examWebBaseUrl.replace(/\/+$/, "");
        var targetUrl = normalizedBaseUrl
            ? "".concat(normalizedBaseUrl, "/login?").concat(query.toString())
            : "/login?".concat(query.toString());
        window.location.assign(targetUrl);
    };
    var mockBannerImage = "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?auto=format&fit=crop&w=1200&q=80";
    return ((0, jsx_runtime_1.jsxs)("section", { className: TicketPage_module_scss_1.default.ticketPage, children: [(0, jsx_runtime_1.jsxs)("div", { className: TicketPage_module_scss_1.default.ticketPageHeader, children: [(0, jsx_runtime_1.jsx)("h1", { className: TicketPage_module_scss_1.default.ticketPageTitle, children: t("TICKET_PAGE_TITLE") }), (0, jsx_runtime_1.jsxs)("p", { className: TicketPage_module_scss_1.default.ticketPageMeta, children: [t("TICKET_PAGE_SESSION_ID"), " ", (0, jsx_runtime_1.jsx)("span", { className: TicketPage_module_scss_1.default.ticketPageMetaValue, children: sessionId || "-" })] })] }), (0, jsx_runtime_1.jsx)("div", { className: TicketPage_module_scss_1.default.ticketList, children: tickets.length > 0 ? (tickets.map(function (ticket) { return ((0, jsx_runtime_1.jsxs)("div", { className: TicketPage_module_scss_1.default.ticketListItem, children: [(0, jsx_runtime_1.jsx)(Ticket_1.default, { candidateName: ticket.title, examDate: t("TICKET_PAGE_EXAM_DATE"), examTime: t("TICKET_PAGE_EXAM_TIME"), subjectCode: ticket.itemId, subjectName: ticket.title, venue: t("TICKET_PAGE_VENUE"), seatNumber: ticket.seatId, barcodeValue: ticket.passkey, contentImageUrl: ticket.imageUrl || mockBannerImage, contentImageAlt: ticket.title, imageTextTone: "dark", enabled: true, onClick: function () { return handleGoExam(ticket); } }), (0, jsx_runtime_1.jsx)("div", { className: TicketPage_module_scss_1.default.ticketActions, children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: TicketPage_module_scss_1.default.ticketActionButton, onClick: function () { return handleGoExam(ticket); }, children: t("TICKET_PAGE_GO_EXAM") }) })] }, ticket.offerId)); })) : ((0, jsx_runtime_1.jsx)("div", { className: TicketPage_module_scss_1.default.ticketEmptyState, children: t("TICKET_PAGE_EMPTY") })) })] }));
};
exports.default = TicketPage;
